// Unified cup constants - single source of truth for all components
export const TOP_BRACKET_CUPS = ['Mushroom', 'Flower', 'Star', 'Special'];
export const BOTTOM_BRACKET_CUPS = ['Banana', 'Shell', 'Leaf', 'Lightning'];
export const ALL_CUPS = [...TOP_BRACKET_CUPS, ...BOTTOM_BRACKET_CUPS];

// Legacy alias for backward compatibility
export const CUPS = ALL_CUPS;

export const CUP_EMOJIS = {
  'Mushroom': '🍄',
  'Flower': '🌸',
  'Star': '⭐',
  'Special': '🏆',
  'Banana': '🍌',
  'Shell': '🐚',
  'Leaf': '🍃',
  'Lightning': '⚡'
};

// Unified placement mapping utility
export const mapRaceToPlacement = (raceData) => {
  if (!raceData || raceData.place === 'X') return 'X';
  return raceData.place;
};

// Points to placement mapping (same for all cups)
export const pointsToPlace = (points) => {
  if (points === 'X') return 'X';
  // Standard scoring: 3 points = 1st place, 0 points = 4th place
  const placeMap = { 3: 1, 2: 2, 1: 3, 0: 4 };
  return placeMap[points] || 4;
};

// Place to points mapping (same for all cups)
export const placeToPoints = (place) => {
  if (place === 'X') return 0;
  // Standard scoring: 1st place = 3 points, 4th place = 0 points
  const pointsMap = { 1: 3, 2: 2, 3: 1, 4: 0 };
  return pointsMap[place] || 0;
};